<p *ngIf="!valid">Sono stati individuati alcuni problemi sull'itinerario</p>

<mat-accordion *ngIf="errors">
  <mat-expansion-panel *ngFor="let errorKey of getErrorKeysWithErrors(errors)">
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <ng-container [ngSwitch]="errorKey">
          <mat-icon class="header-icon" *ngSwitchCase="'info'">info</mat-icon>
          <mat-icon class="header-icon" *ngSwitchCase="'flights'"
            >flight</mat-icon
          >
          <mat-icon class="header-icon" *ngSwitchCase="'accomodations'"
            >hotel</mat-icon
          >
          <mat-icon class="header-icon" *ngSwitchCase="'trains'"
            >train</mat-icon
          >
          <mat-icon class="header-icon" *ngSwitchCase="'ferries'"
            >directions_boat</mat-icon
          >
          <mat-icon class="header-icon" *ngSwitchCase="'buses'"
            >directions_bus</mat-icon
          >
          <mat-icon class="header-icon" *ngSwitchCase="'cars'"
            >directions_car</mat-icon
          >
          <mat-icon class="header-icon" *ngSwitchCase="'days'">map</mat-icon>
          <mat-icon class="header-icon" *ngSwitchCase="'overflows'"
            >subject</mat-icon
          >
        </ng-container>

        <span
          class="header-title"
          fxFlex
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <ng-container [ngSwitch]="errorKey">
            <span *ngSwitchCase="'info'">Info Generali</span>
            <span *ngSwitchCase="'flights'">Voli</span>
            <span *ngSwitchCase="'trains'">Treni</span>
            <span *ngSwitchCase="'ferries'">Navi</span>
            <span *ngSwitchCase="'buses'">Autobus</span>
            <span *ngSwitchCase="'cars'">Altri mezzi</span>
            <span *ngSwitchCase="'accomodations'">Alloggi</span>
            <span *ngSwitchCase="'days'">Giorni</span>
            <span *ngSwitchCase="'overflows'">Lunghezza testi</span>
          </ng-container>
          &nbsp;<mat-icon>chevron_right</mat-icon>
          {{ errors[errorKey].length }}&nbsp;
          <span *ngIf="errors[errorKey].length === 1">problema</span
          ><span *ngIf="errors[errorKey].length > 1">problemi</span>
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-nav-list>
      <mat-list-item *ngFor="let error of errors[errorKey]">
        <a
          matLine
          [routerLink]="error.routerLink"
          (click)="errorClick.emit()"
          fxLayout="row"
          fxLayoutAlign="start center"
          ><mat-icon class="icon-error">close</mat-icon>&nbsp;&nbsp;
          {{ error.message }}</a
        >
      </mat-list-item>
    </mat-nav-list>
  </mat-expansion-panel>
</mat-accordion>
